import { useCallback } from 'react';
import { useQuery } from '@apollo/client';
import { QUERY_FETCH_RESOURCE_HUB_PAGE } from '@edwin-group/people-graphql';
import type { FetchResourceHubPageQuery } from '@edwin-group/people-graphql';
import { ResourceCard } from '@/components/ResourceCard';
import { useProfileStore } from '../../store/useProfileStore';
import { useDownloadedResources } from './useDownloadedResources';

export const DownloadedResources = () => {
  const page = useProfileStore((state) => state.page);
  const title = page?.latestResourcesDownloadedTitle ?? 'Latest resources downloaded';
  const emptyMessage = page?.noDownloadedResourcesMessage ?? 'You have not downloaded any resources yet';

  const { data: resourceHubPageData } = useQuery<FetchResourceHubPageQuery>(QUERY_FETCH_RESOURCE_HUB_PAGE, {
    fetchPolicy: 'cache-first',
  });
  const linkText = resourceHubPageData?.resourceHubPage?.cardLinkText ?? 'Go to resource';

  const { resources, loading, hasResources } = useDownloadedResources(9);

  const renderSkeleton = useCallback(() => {
    return (
      <div className="grid grid-cols-1 gap-[25px] md:grid-cols-2">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="h-48 animate-pulse rounded-[6px] bg-gray-100" />
        ))}
      </div>
    );
  }, []);

  return (
    <section>
      <h2 className="mb-[32px] text-sh-md text-dark-grey">{title}</h2>
      {loading && !hasResources ? (
        renderSkeleton()
      ) : !hasResources ? (
        <div className="py-sh-60 text-center">
          <p className="font-cadiz text-sh-16-24 text-gray-500">{emptyMessage}</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-[25px] md:grid-cols-2">
          {resources.map((resource) => (
            <ResourceCard key={resource.documentId} resource={resource} linkText={linkText} hideStatusBadges={true} />
          ))}
        </div>
      )}
    </section>
  );
};

export default DownloadedResources;
